export default __webpack_public_path__ + "static/media/marko.5b7851fa.svg";